export const screens = {
    mobileSm: `(max-width:540px)`,
    mobileL: `(max-width:768px)`,
    tablet: ` (max-width:1024px)`,
}